import React from 'react';
import classes from "./AboutDescription.module.css";

export default function AboutDescription() {
  return (
    <>
      <div className={classes.AboutDescription}>
        <p>Being tired of commonplace exaggerated projects, the Birds are creating an investment group to contribute their time and talent to the development and promotion of projects in the <span>SOLANA ecosystem</span>. And, of course, to make money on it...</p>
        <div className={classes.about_shape}>
          <svg width="1298" height="530" viewBox="0 0 1298 530" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M95.167 2C0.735078 83.3371 -26.1366 232.999 34.0995 342.092C69.9186 406.964 131.431 455.252 199.516 484.521C267.601 513.79 342.139 525.288 416.163 528.821C592.209 537.202 771.007 500.937 926.942 418.838C1082.88 336.739 1215.08 208.311 1296 51.7918" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className={classes.responsive_shape}>
          <svg width="382" height="284" viewBox="0 0 382 284" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M331.177 1C381.676 44.4414 396.047 124.375 363.834 182.64C344.679 217.287 311.783 243.078 275.373 258.71C238.963 274.343 199.102 280.484 159.516 282.37C65.3704 286.847 -30.2465 267.478 -113.637 223.629C-197.027 179.781 -267.725 111.189 -311 27.5933" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
    </>
  )
}
